import type React from "react";
import { useIntl } from "react-intl";

interface TotalItemsSectionProps {
	count: number;
}

export const TotalItemsSection: React.FC<TotalItemsSectionProps> = ({ count }) => {
	const intl = useIntl();

	const suffix =
		count === 1
			? intl.formatMessage({ id: "Item", defaultMessage: "Item" })
			: intl.formatMessage({ id: "Items", defaultMessage: "Items" });
	return `${count} ${suffix}`;
};
